function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { PRINTER_DRIVER_TYPE } from "@dpdgroupuk/mydpd-enums";
import AbstractPrinterDriver from "./AbstractPrinterDriver";
import PrinterError, { STATUS_CODE } from "./PrinterError";
import { M } from "../../constants";

class ServiceThermalDriver extends AbstractPrinterDriver {
  async configure() {
    let foundPrinter;

    try {
      const {
        data: printers = []
      } = await this.printer.localApis.printer.getPrinters();
      foundPrinter = printers.find(printer => printer.deviceName === this.printer.config.thermalPrinterName);
    } catch (err) {
      throw new PrinterError(`Thermal printer is configured to use ${M.MYDPD_CUSTOMER_APP}, but it is not responding`, STATUS_CODE.PRINTER_NOT_RESPOND);
    }

    if (!foundPrinter) {
      throw new PrinterError(`Cannot detect ${this.printer.config.thermalPrinterName} printer`, STATUS_CODE.PRINTER_NOT_FOUND);
    }
  }

  async print(labels) {
    return this.printer.localApis.printer.printLabels({
      labels,
      printerName: this.printer.config.thermalPrinterName
    });
  }

}

_defineProperty(ServiceThermalDriver, "DRIVER_TYPE", PRINTER_DRIVER_TYPE.MYDPD_SERVICE);

export default ServiceThermalDriver;